import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=a5ee9a8e&scoped=true&"
import script from "./Check.vue?vue&type=script&lang=ts&"
export * from "./Check.vue?vue&type=script&lang=ts&"
import style0 from "./Check.vue?vue&type=style&index=0&id=a5ee9a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ee9a8e",
  null
  
)

export default component.exports